const TabState = {
    PRODUCTS: 'PRODUCTS',
    ARTICLES: 'ARTICLES',
};

export default TabState;
